import { useIsTeacher } from '@reducers/user/hooks';
import React, { Suspense } from 'react';
import ShowIf from '@components/Atoms/ShowIf';
import Box from '@components/Atoms/Box';
import Skeleton from '@components/Atoms/Skeleton';
import { useParams } from 'react-router-dom';
import StudentTestCard from '../StudentTestCard';
import { useGetTestlets } from '../../hooks';

const StudentTestletView = () => {
  const isTeacher = useIsTeacher();
  const { testSessionId, testletId } = useParams();
  const { data: testlets } = useGetTestlets(+testSessionId);
  const testlet = testlets?.find((t) => t.id === parseInt(testletId, 10));
  if (!testlet) {
    return null;
  }

  return (
    <Suspense fallback={<Skeleton variant="rectangular" width="100%" height={400} />}>
      <ShowIf If={!isTeacher}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <StudentTestCard testlet={testlet} />
        </Box>
      </ShowIf>
    </Suspense>
  );
};

export default StudentTestletView;
